import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'
const Login = lazyRouteComponent(() => import('../pages/login'))

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
})
